import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { KomitentObjekatUpisnoMesto } from './komitent-objekat-upisno-mesto';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-komitent-objekat-upisno-mesto-modal-update',
  templateUrl: './komitent-objekat-upisno-mesto-modal-update.component.html'
})
export class KomitentObjekatUpisnoMestoModalUpdateComponent extends BaseModalUpdateComponent<KomitentObjekatUpisnoMesto> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<KomitentObjekatUpisnoMesto>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
